import { Button, CircularProgress } from "@mui/material";
import React from "react";

interface ButtonProps {
  label: string;
  disabled?: boolean;
  loading: boolean;
}

const AppSubmitButton: React.FC<ButtonProps> = ({
  disabled,
  loading,
  label,
}) => {
  return (
    <Button
      variant="contained"
      color="warning"
      disabled={disabled}
      type="submit"
      size="large"
      fullWidth
      sx={{
        padding: "12px 10px",
        borderRadius: "10px",
        textTransform: "none",
        fontSize: 18,
        fontFamily: "Lato-Bold",
      }}
    >
      {loading ? <CircularProgress color="inherit" /> : label}
    </Button>
  );
};

export default AppSubmitButton;
